import { render, staticRenderFns } from "./CreatePoint.vue?vue&type=template&id=990dd7b6&"
import script from "./CreatePoint.vue?vue&type=script&lang=js&"
export * from "./CreatePoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports